import { render, staticRenderFns } from "./freightEdit.vue?vue&type=template&id=166113fa&scoped=true&"
import script from "./freightEdit.vue?vue&type=script&lang=ts&"
export * from "./freightEdit.vue?vue&type=script&lang=ts&"
import style0 from "./freightEdit.vue?vue&type=style&index=0&id=166113fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166113fa",
  null
  
)

export default component.exports